export const IS_MOBILE = 'IS_MOBILE'
export const TOGGLE = 'TOGGLE'
//-------------------auth-------------------------
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const REQUEST_USER = 'REQUEST_USER'
export const SUCCESS_USER = 'SUCCESS_USER'
export const ERROR_USER = 'ERROR_USER'
//------------------------------------------------

//-------------------catalog-----------------------
export const REQUEST_CATALOG = 'REQUEST_CATALOG'
export const SUCCESS_CATALOG = 'SUCCESS_CATALOG'
export const ERROR_CATALOG = 'ERROR_CATALOG'

export const REQUEST_LOCALITY = 'REQUEST_LOCALITY'
export const SUCCESS_LOCALITY = 'SUCCESS_LOCALITY'
//------------------------------------------------

//-------------------recipient-------------------------
export const GET_RECIPIENT = 'GET_RECIPIENT'
export const GET_RECIPIENTS = 'SET_RECIPIENTS'
//recipient inputs selects
export const RECIPIENT_REGION = 'RECIPIENT_REGION'
export const RECIPIENT_CITY = 'RECIPIENT_CITY'
export const RECIPIENT_EDRPOU = 'RECIPIENT_EDRPOU'
export const RECIPIENT_TITLE = 'RECIPIENT_TITLE'
export const RECIPIENT_SURNAME = 'RECIPIENT_SURNAME'
export const RECIPIENT_NAME = 'RECIPIENT_NAME'
export const RECIPIENT_LASTNAME = 'RECIPIENT_LASTNAME'
export const RECIPIENT_PHONE = 'RECIPIENT_PHONE'
export const RECIPIENT_EMAIL= 'RECIPIENT_EMAIL'
export const RECIPIENT_ADDRESS= 'RECIPIENT_ADDRESS'
export const RECIPIENT_KOATUU= 'RECIPIENT_KOATUU'

export const RECIPIENT_ID = 'RECIPIENT_ID'
export const REQUEST_RECIPIENT = 'REQUEST_RECIPIENT'
export const SUCCESS_RECIPIENT = 'SUCCESS_RECIPIENT'
export const ERROR_RECIPIENT = 'ERROR_RECIPIENT'

export const REQUEST_RECIPIENTS = 'REQUEST_RECIPIENTS'
export const SUCCESS_RECIPIENTS = 'SUCCESS_RECIPIENTS'
export const ERROR_RECIPIENTS = 'ERROR_RECIPIENTS'

export const REQUEST_APPLY_APP = 'REQUEST_APPLY_APP'
export const SUCCESS_APPLY_APP = 'SUCCESS_APPLY_APP'
export const ERROR_APPLY_APP = 'ERROR_APPLY_APP'

export const REQUEST_APPROVE = 'REQUEST_APPROVE'
export const SUCCESS_APPROVE = 'SUCCESS_APPROVE'
export const ERROR_APPROVE = 'ERROR_APPROVE'

export const REQUEST_DENIED = 'REQUEST_DENIED'
export const SUCCESS_DENIED = 'SUCCESS_DENIED'
export const ERROR_DENIED = 'ERROR_DENIED'

export const REQUEST_RECIPIENT_SAVE = 'REQUEST_RECIPIENT_SAVE'
export const SUCCESS_RECIPIENT_SAVE = 'SUCCESS_RECIPIENT_SAVE'
export const ERROR_RECIPIENT_SAVE = 'ERROR_RECIPIENT_SAVE'

export const APPLICATION_ID = 'APPLICATION_ID'
 
//RECIPIENT DOCUMENTS
export const REQUEST_RECIPIENT_DOCUMENTS_SAVE = 'REQUEST_RECIPIENT_DOCUMENTS_SAVE';
export const SUCCESS_RECIPIENT_DOCUMENTS_SAVE = 'SUCCESS_RECIPIENT_DOCUMENTS_SAVE';
export const ERROR_RECIPIENT_DOCUMENTS_SAVE = 'ERROR_RECIPIENT_DOCUMENTS_SAVE';

export const SUCCESS_RECIPIENT_DOCUMENTS = 'SUCCESS_RECIPIENT_DOCUMENTS';
export const ERROR_RECIPIENT_DOCUMENTS = 'ERROR_RECIPIENT_DOCUMENTS';
export const REQUEST_RECIPIENT_DOCUMENTS = 'REQUEST_RECIPIENT_DOCUMENTS';

export const SUCCESS_RECIPIENT_DOCUMENTS_DEL = 'SUCCESS_RECIPIENT_DOCUMENTS_DEL';
export const ERROR_RECIPIENT_DOCUMENTS_DEL = 'ERROR_RECIPIENT_DOCUMENTS_DEL';
export const REQUEST_RECIPIENT_DOCUMENTS_DEL = 'REQUEST_RECIPIENT_DOCUMENTS_DEL';

//


export const RECIPIENT_CLEAR= 'RECIPIENT_CLEAR'
export const RECIPIENTS_CLEAR= 'RECIPIENTS_CLEAR'

export const SUCCESS_RECIPIENT_APPLICATIONS_HISTORY = 'SUCCESS_RECIPIENT_APPLICATIONS_HISTORY';
export const ERROR_RECIPIENT_APPLICATIONS_HISTORY = 'ERROR_RECIPIENT_APPLICATIONS_HISTORY';
export const REQUEST_RECIPIENT_APPLICATIONS_HISTORY = 'REQUEST_RECIPIENT_APPLICATIONS_HISTORY';


export const SUCCESS_DELETE_RECIPIENT = 'SUCCESS_DELETE_RECIPIENT';
export const ERROR_DELETE_RECIPIENT = 'ERROR_DELETE_RECIPIENT';
export const REQUEST_DELETE_RECIPIENT = 'REQUEST_DELETE_RECIPIENT';

export const SUCCESS_RECIPIENTS_SELECT = 'SUCCESS_RECIPIENTS_SELECT';
export const ERROR_RECIPIENTS_SELECT = 'ERROR_RECIPIENTS_SELECT';
export const REQUEST_RECIPIENTS_SELECT = 'REQUEST_RECIPIENTS_SELECT';

export const REQUEST_RECIPIENT_DELETE_FROM_REGISTER = 'REQUEST_RECIPIENT_DELETE_FROM_REGISTER'
export const SUCCESS_RECIPIENT_DELETE_FROM_REGISTER = "SUCCESS_RECIPIENT_DELETE_FROM_REGISTER";
export const ERROR_RECIPIENT_DELETE_FROM_REGISTER = "ERROR_RECIPIENT_DELETE_FROM_REGISTER";
//--------------------------------------------

//-----------------cargo-------------------------
export const REQUEST_CARGO_BY_ID = 'REQUEST_CARGO_BY_ID';
export const SUCCESS_CARGO_BY_ID = 'SUCCESS_CARGO_BY_ID';
export const ERROR_CARGO_BY_ID = 'ERROR_CARGO_BY_ID';

export const CARGO_RECIPIENT_NAME_SELECT = 'RECIPIENT_NAME_SELECT'
export const CARGO_DONOR_NAME = 'CARGO_DONOR_NAME'
export const CARGO_DONOR_DETAILS = 'CARGO_DONOR_DETAILS'
export const CARGO_DONOR_COUNTRY_SELECT= 'CARGO_DONOR_COUNTRY_SELECT'
export const CARGO_SENDING_COUNTRY_SELECT= 'CARGO_SENDING_COUNTRY_SELECT'
export const CARGO_ACQUIRER_TYPE_SELECT = 'CARGO_ACQUIRER_TYPE_SELECT'
export const CARGO_ACQUIRER_MAIN_NAME = 'CARGO_ACQUIRER_MAIN_NAME'
export const CARGO_ACQUIRER_SURNAME = 'CARGO_ACQUIRER_SURNAME'
export const CARGO_ACQUIRER_NAME = 'CARGO_ACQUIRER_NAME'
export const CARGO_ACQUIRER_LASTNAME = 'CARGO_ACQUIRER_LASTNAME'
export const CARGO_ACQUIRER_SOCIAL_CATEGORY = 'CARGO_ACQUIRER_SOCIAL_CATEGORY'
export const CARGO_ACQUIRER_REGION = 'CARGO_ACQUIRER_REGION'
export const CARGO_ACQUIRER_LOCALITY = 'CARGO_ACQUIRER_LOCALITY'
export const CARGO_ACQUIRER_LOCATION = 'CARGO_ACQUIRER_LOCATION'
export const CARGO_ACQUIRER_PHONE = 'CARGO_ACQUIRER_PHONE'
export const CARGO_ACQUIRER_COUNT_PLAN = 'CARGO_ACQUIRER_COUNT_PLAN'
export const CARGO_AID_TYPE_SELECT = 'CARGO_AID_TYPE_SELECT'

export const CARGO_DESCRIPTION = 'CARGO_DESCRIPTION'
export const CARGO_DESCRIPTION_SELECT = 'CARGO_DESCRIPTION_SELECT'
export const CARGO_QUONTITY = 'CARGO_QUONTITY'
export const CARGO_UNIT = 'CARGO_UNIT'
export const CARGO_CONDITION = 'CARGO_CONDITION'
export const CARGO_ADD = 'CARGO_ADD'
export const CARGO_DELETE = 'CARGO_DELETE'
export const CARGO_SET_ARRAY = 'CARGO_SET_ARRAY'

export const SET_CURGO_BY_RECIPIENT = 'SET_CURGO_BY_RECIPIENT'


export const REQUEST_CARGO_SAVE = 'REQUEST_CARGO_SAVE'
export const SUCCESS_CARGO_SAVE = 'SUCCESS_CARGO_SAVE'
export const ERROR_CARGO_SAVE = 'ERROR_CARGO_SAVE'


export const APPLICATION_CARGO_ID ="APPLICATION_CARGO_ID"
export const CARGO_ID ="CARGO_ID"
export const REQUEST_MY_CARGO ="REQUEST_MY_CARGO"
export const SUCCESS_MY_CARGO ="SUCCESS_MY_CARGO"
export const ERROR_MY_CARGO ="ERROR_MY_CARGO"
//CARGO DOCUMENTS

export const REQUEST_CARGO_DOCUMENTS_SAVE = 'REQUEST_CARGO_DOCUMENTS_SAVE'
export const SUCCESS_CARGO_DOCUMENTS_SAVE = 'SUCCESS_CARGO_DOCUMENTS_SAVE'
export const ERROR_CARGO_DOCUMENTS_SAVE = 'ERROR_CARGO_DOCUMENTS_SAVE'

export const REQUEST_CARGO_DOCUMENTS = 'REQUEST_CARGO_DOCUMENTS'
export const SUCCESS_CARGO_DOCUMENTS = 'SUCCESS_CARGO_DOCUMENTS'
export const ERROR_CARGO_DOCUMENTS = 'ERROR_CARGO_DOCUMENTS'

export const REQUEST_CARGO_DOCUMENTS_DEL = 'REQUEST_CARGO_DOCUMENTS_DEL'
export const SUCCESS_CARGO_DOCUMENTS_DEL = 'SUCCESS_CARGO_DOCUMENTS_DEL'
export const  ERROR_CARGO_DOCUMENTS_DEL = ' ERROR_CARGO_DOCUMENTS_DEL'

export const REQUEST_CARGO_REPORT = 'REQUEST_CARGO_REPORT'
export const SUCCESS_CARGO_REPORT = 'SUCCESS_CARGO_REPORT'
export const ERROR_CARGO_REPORT = ' ERROR_CARGO_REPORT'

export const CARGO_CLEAR= 'CARGO_CLEAR'
export const AQUIRERE_ADD = 'AQUIRERE_ADD'
export const AID_ID = 'AID_ID'
export const CARGO_AID_COLLECTION = 'CARGO_AID_COLLECTION'
export const SUCCESS_AQUIRER_BY_ID = 'SUCCESS_AQUIRER_BY_ID'
export const REQUEST_AQUIRER_BY_ID = 'REQUEST_AQUIRER_BY_ID'
export const ERROR_AQUIRER_BY_ID = 'ERROR_AQUIRER_BY_ID'
export const CLEAR_AQCUIRER = 'CLEAR_AQCUIRER'
export const EDIT_AID_ACTION = 'EDIT_AID_ACTION'
export const DISTRIBUTIONS = 'DISTRIBUTIONS'
export const EDIT_UNIT = 'EDIT_UNIT'

//commission
    //сommission create
export const SELECT_APPLICATIONS = "SELECT_APPLICATIONS" //push cheched it into array
export const SUCCESS_APPLICATIONS = "SUCCESS_APPLICATIONS" //get data for table from server
export const CHECK_APPLICATION = "CHECK_APPLICATION" //when all cheched flag is true
export const TABLE_CHANGE = "TABLE_CHANGE" //renew table data after checking
export const SELECT_CLEAR = "SELECT_CLEAR" //clear
    //сommission data
export const COMMISSION_SET = "COMMISSION_SET" 
export const COMMISSION_CLEAR = 'COMMISSION_CLEAR'
export const COMMISION_ID = 'COMMISION_ID'
export const SET_MEETING = 'SET_MEETING'


export const REQUEST_APPLICATIONS = "REQUEST_APPLICATIONS"
export const  ERROR_APPLICATIONS = "ERROR_APPLICATIONS"
export const  SUCCESS_CARGO_APPLICATIONS = "SUCCESS_CARGO_APPLICATIONS"

export const RECIPIENT_NEW = "RECIPIENT_NEW"
export const RECIPIENT_OLD = "RECIPIENT_OLD"
export const CARGO_NEW = "CARGO_NEW"
export const CARGO_OLD = "CARGO_OLD"
export const TYPE_MEETING = "TYPE_MEETING"

export const CHANGE_POSITION_PROFILE = 'CHANGE_POSITION_PROFILE'
export const CHANGE_EMAIL_PROFILE = 'CHANGE_EMAIL_PROFILE'

